import EntityChip from '@/atoms/chips/EntityChip';
import Paragraph from '@/atoms/typography/Paragraph';
import Size from '@enums/Size';
import Stack from '@mui/material/Stack';

const EntityLabel = ({ item }) => {
  const { label, type } = item;

  return (
    <>
      <Stack direction="row" spacing={1}>
        <EntityChip type={type} size={Size.XX_SMALL} />
      </Stack>
      <Paragraph size={Size.SMALL} overrideStyles={{ mb: 0, mt: 0.5 }}>
        {label}
      </Paragraph>
    </>
  );
};

export default EntityLabel;
